const compliance = {
  name: 'compliance',

  path: 'compliance',

  async getComponent() {
    const {ComplianceMain} = await import('./ComplianceRoutes');

    return ComplianceMain;
  },

  async getChildRoutes() {
    const { ComplianceRoutes } = await import('./ComplianceRoutes');

    return ComplianceRoutes;
  }
};

export default compliance;



// WEBPACK FOOTER //
// ./src/apps/Compliance/index.js